import { render, staticRenderFns } from "./Product-tabs.vue?vue&type=template&id=ac300772&"
import script from "./Product-tabs.vue?vue&type=script&lang=js&"
export * from "./Product-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports